<div class="modal inmodal fade in parcel-modal create-modal" [ngClass]="{'show': showModal}">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog ">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">Invitation Template</h4>
                </div>
                <div class="modal-body">
                    <div [ngClass]="{'welcome-header' : showEditPanel}" (dblclick)="showEditPanelSetter()">
                        <h3>
                            <i *ngIf="!showEditPanel" class="fa fa-pencil"
                               (click)="showEditPanelSetter()"
                               data-placement="top" data-toggle="tooltip" title="Edit"></i>
                        </h3>
                        <div *ngIf="!showEditPanel" class="row m-b-md">
                            <div class="col-md-2">
                                <label>Subject</label>
                            </div>
                            <div class="col-md-10 fourteenPixelText">
                                <div>{{invitationSubject}}</div>
                            </div>
                        </div>
                        <div *ngIf="!showEditPanel" [innerHtml]="invitationEmail | safeHtml"></div>
                        <div *ngIf="showEditPanel" class="dv-value-edit">
                            <button type="submit" [disabled]="disabledSubmit">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button" (click)="closeEditPanel()">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>

                    <div  *ngIf="showEditPanel" class="row m-b-md">
                        <div class="col-md-2">
                            <label>Subject</label>
                        </div>
                        <div class="col-md-10 fourteenPixelText">
                            <div>
                                <input class="form-control"
                                       name="subject"
                                       [(ngModel)]="invitationSubject">
                            </div>
                        </div>
                    </div>

                    <div *ngIf="showEditPanel">
                        <div class="form-group" id="summernote">{{invitationEmail | safeHtml}}</div>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/invitation-email-modal/invitation-email-modal.component.html